export default "__VITE_ASSET__BbC82O_m__"